import { useAuth } from '@/lib/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { purchasedCoursesCategoryQueryOptions } from './purchasedCoursesQueries';

export function useHasPurchasedLifetimeCourses() {
  const { user } = useAuth();
  const userId = user?.id ?? null;

  const query = useQuery(purchasedCoursesCategoryQueryOptions(userId));

  return {
    hasPurchasedLifetimeCourses: (query.data?.courses.length ?? 0) > 0,
    isLoading: query.isLoading,
  };
}
